import { render, staticRenderFns } from "./HealthInstitution.vue?vue&type=template&id=96226938"
import script from "./HealthInstitution.vue?vue&type=script&lang=js"
export * from "./HealthInstitution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports